// Hide grid until split is done
const style = document.createElement('style');
style.textContent = '.product-grid__item { visibility: hidden; }';
document.head.appendChild(style);

document.addEventListener('DOMContentLoaded', function () {
  splitVariantCards();
  // Show all cards after split
  style.textContent = '.product-grid__item { visibility: visible; }';
});

function splitVariantCards() {
  const productItems = document.querySelectorAll('.product-grid__item[data-variants]');

  productItems.forEach((item) => {
    const ids = item.dataset.variants.split(',');
    if (ids.length <= 1) return;

    const titles = item.dataset.variantTitles.split('||');
    const prices = item.dataset.variantPrices.split(',');
    const comparePrices = item.dataset.variantComparePrices.split(',');
    const images = item.dataset.variantImages.split('||');
    const productTitle = item.dataset.productTitle;
    const handle = item.dataset.productHandle;
    const parent = item.parentNode;

    ids.forEach((id, index) => {
      const variant = {
        id: id.trim(),
        title: titles[index] || '',
        price: parseInt(prices[index]) || 0,
        compare_at_price: parseInt(comparePrices[index]) || 0,
        featured_image: images[index] === 'null' ? null : images[index],
        handle: handle
      };

      if (index === 0) {
        updateCard(item, productTitle, variant);
      } else {
        const clone = item.cloneNode(true);
        item.parentNode.insertBefore(clone, item.nextSibling);
        updateCard(clone, productTitle, variant);
      }
    });
  });
}

function updateCard(card, productTitle, variant) {
  // Update all links
  card.querySelectorAll('a').forEach((link) => {
    if (link.href && link.href.includes('/products/')) {
      link.href = `/products/${variant.handle}?variant=${variant.id}`;
    }
  });

  // Update title
  const titleEl = card.querySelector('p[role="heading"]');
  if (titleEl) {
    titleEl.textContent = `${productTitle} - ${variant.title}`;
  }

  // Update price
  const saleEl = card.querySelector('.price-item--sale');
  const regularEl = card.querySelector('.price-item--regular');
  const plainPriceEl = card.querySelector('.price__regular .price');

  const price = `Rs. ${(variant.price / 100).toFixed(2)} INR`;
  const comparePrice = `Rs. ${(variant.compare_at_price / 100).toFixed(2)} INR`;

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    if (saleEl) saleEl.textContent = price;
    if (regularEl) regularEl.textContent = comparePrice;
  } else {
    if (plainPriceEl) plainPriceEl.textContent = price;
    if (saleEl) saleEl.textContent = price;
  }

  // Update image
  if (variant.featured_image) {
    const firstImg = card.querySelector('img');
    if (firstImg) {
      firstImg.src = variant.featured_image;
      firstImg.srcset = '';
    }
  }

  // Update quick add variant id
  const variantInput = card.querySelector('input[ref="variantId"], input[name="id"]');
  if (variantInput) variantInput.value = variant.id;

  card.dataset.productId = card.dataset.productId + '-' + variant.id;
}